import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { downgradeInjectable } from '@angular/upgrade/static'
import { LogisticNote } from '@tradecafe/types/core'
import { AngularCopy } from 'src/decorators/angular-copy.decorator'
import { AngularParams, HaveAngularParams } from 'src/decorators/angular-params.decorator'
import { environment } from 'src/environments/environment'


const { apiUrl } = environment


export default module =>
  module.service('LogisticNoteApi', downgradeInjectable(LogisticNoteApiService))


@Injectable()
@AngularCopy()
export class LogisticNoteApiService {
  private http = inject(HttpClient)


  @HaveAngularParams()
  list(@AngularParams() params) {
    return this.http.get<{ data: LogisticNote[] }>(`${apiUrl}/logistic-notes`, { params }).toPromise()
  }

  create(data: Partial<LogisticNote>) {
    return this.http.post<{ data: LogisticNote }>(`${apiUrl}/logistic-notes`, data).toPromise()
  }

  get(id: string) {
    return this.http.get<{ data: LogisticNote }>(`${apiUrl}/logistic-notes/${id}`).toPromise()
  }

  update(id: string, data: Partial<LogisticNote>) {
    return this.http.put<{ data: LogisticNote }>(`${apiUrl}/logistic-notes/${id}`, data).toPromise()
  }

  delete(id: string) {
    return this.http.delete<{ data: LogisticNote }>(`${apiUrl}/logistic-notes/${id}`).toPromise()
  }
}
